import styled from "styled-components";
import { flexcv } from "../globalStyle";

export const InnerWrapper = styled.div`
  width: 80%;
  margin: 20px auto;

  ${flexcv}
  gap:20px;
`;
